import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActivityTypesService } from '../activity-types/logic/activity-types.service';
import { AppParameterService } from '../app-parameter/logic/app-parameter.service';
import { ArchivesService } from '../archives/logic/archives.service';
import { BranchTypesService } from '../branch-types/logic/branch-types.service';
import { BranchesService } from '../branches/logic/branches.service';
import { PersonsService } from '../persons/logic/persons.service';
import { BranchFunctionGroupsService } from '../branch-function-groups/logic/branch-function-groups.service';
import { EmployeeFunctionGroupsService } from '../employee-function-groups/logic/employee-function-groups.service';
import { CargoItemTypesService } from '../cargo-item-types/logic/cargo-item-types.service';
import { CarsService } from '../cars/logic/cars.service';
import { ClientStateService } from '../client-state/logic/client-state.service';
import { EmployeeService } from '../employee/logic/employee.service';
import { EquipmentsService } from '../equipments/logic/equipments.service';
import { MaskDefinitionService } from '../mask-definition/logic/mask-definition.service';
import { MenuService } from '../menu/logic/menu.service';
import { PinTypesService } from '../pin-types/logic/pin-types.service';
import { PinsService } from '../pins/logic/pins.service';
import { ProcessStepsService } from '../process-steps/logic/process-steps.service';
import { ServicejobsService } from '../servicejobs/logic/servicejobs.service';
import { TagStatesService } from '../tag-states/logic/tag-states.service';
import { WorktypesService } from '../worktypes/logic/worktypes.service';
import { SyncService } from './sync.service';
import { SyncDiagnosticsService } from './sync-diagnostics.service';
import { Syncable } from './syncable';
import { DeficiencyTicketsService } from '../deficiency-ticket/logic/deficiency-tickets.service';
import { DeficiencyTicketWatchersService } from '../deficiency-ticket-watchers/logic/deficiency-ticket-watchers.service';
import { ExtFilesService } from '../ext-files/logic/ext-files.service';
import { PeripheralsService } from '../peripherals/logic/peripherals.service';
import { RequiredUserActionsService } from '../required-user-actions/logic/required-user-actions.service';
import { TranslationsService } from '../translations/logic/translations.service';
import { JobSectionsService } from '../job-section/logic/job-section.service';
import { MaterialDemandInfosService } from '../materialdemandinfo/logic/materialdemandinfos.service';
import { AccessibilityService } from '../accessibility/accessibility.service';
import { FunctionGroupsService } from '../function-group/logic/function-groups.service';
import { ObjectIdLabelService } from '../object-id-label/logic/object-id-label.service';
import { CellphonesService } from '../cellphones/logic/cellphones.service';
import { ProjectContactDirectoryService } from '../project-contact-directory/logic/project-contact-directory.service';
import { ActivityConfirmationsService } from '../activity-confirmations/logic/activity-confirmations.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: Syncable,
      useExisting: AppParameterService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: EmployeeService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: MenuService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: MaskDefinitionService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: WorktypesService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: ActivityTypesService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: ProcessStepsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: FunctionGroupsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: ArchivesService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: BranchesService,
      multi: true,
    },
    // Persons/BranchFunctionGroups depend on the branches synced just above to build branchidsstr
    {
      provide: Syncable,
      useExisting: PersonsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: BranchFunctionGroupsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: EmployeeFunctionGroupsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: BranchTypesService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: CarsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: CargoItemTypesService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: ServicejobsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: EquipmentsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: PinTypesService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: PinsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: DeficiencyTicketsService,
      multi: true,
    },
    // DeficiencyTicketWatchers must sync directly after DeficiencyTickets,
    // it needs the just-synced deficiencyticketidlist to scope its request
    {
      provide: Syncable,
      useExisting: DeficiencyTicketWatchersService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: TagStatesService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: ClientStateService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: PeripheralsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: RequiredUserActionsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: TranslationsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: JobSectionsService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: MaterialDemandInfosService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: ObjectIdLabelService,
      multi: true,
    },
    // Ensure that AppParams are synced first, so other services can use them
    {
      provide: Syncable,
      useExisting: AccessibilityService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: CellphonesService,
      multi: true,
    },
    {
      provide: Syncable,
      useExisting: ProjectContactDirectoryService,
      multi: true,
    },
    // ActivityConfirmations must sync before ExtFiles, the ExtFile draft
    // handling builds on the AC infos
    {
      provide: Syncable,
      useExisting: ActivityConfirmationsService,
      multi: true,
    },
    // ExtFiles need to be synced last, so all the subscriptions are correct set
    {
      provide: Syncable,
      useExisting: ExtFilesService,
      multi: true,
    },
    SyncService,
    SyncDiagnosticsService,
  ],
})
export class SyncModule {}
